import { captureException, configureScope, init } from '@sentry/browser';
import Store from 'repatch';

import State from '../core/State';

class ErrorReporter {
  private store: Store<State>;

  constructor({
    store,
    dsn,
    environment,
    release,
  }: {
    store: Store<State>;
    dsn: string;
    environment: string;
    release: string;
  }) {
    this.store = store;
    init({
      dsn: dsn,
      environment: environment,
      release,
    });
  }

  public reportError = (err: Error) => {
    console.log(err);
    const state: State = this.store.getState();
    configureScope(scope => {
      if (state.authentication.signedInUser) {
        scope.setUser({
          id: state.authentication.signedInUser.id,
          username: state.authentication.signedInUser.name,
          email: state.authentication.signedInUser.email ? state.authentication.signedInUser.email : undefined,
        });
      }
      scope.setExtras(state);
    });
    captureException(err);
    window.newrelic.noticeError(err);
  };
}

export default ErrorReporter;
